import * as debounce from "debounce";

let heightLimit = 200; /* Maximum height: 200px */

$('.auto-expanding').on('input', debounce(autoExpanding, 100));
$(window).on('resize', debounce(autoExpanding, 300));

function autoExpanding () {
    let expand = $('.auto-expanding').get(0);
    expand.style.height = ""; /* Reset the height*/
    expand.style.height = Math.min(expand.scrollHeight + 4, heightLimit) + "px";
}
